import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\src\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7d1224e2 from 'nuxt_plugin_plugin_7d1224e2' // Source: .\\components\\plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_1354cf08 from 'nuxt_plugin_pluginutils_1354cf08' // Source: .\\nuxt-i18n\\plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6d51f6c7 from 'nuxt_plugin_pluginrouting_6d51f6c7' // Source: .\\nuxt-i18n\\plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_fb367bf0 from 'nuxt_plugin_pluginmain_fb367bf0' // Source: .\\nuxt-i18n\\plugin.main.js (mode: 'all')
import nuxt_plugin_axios_6cf30032 from 'nuxt_plugin_axios_6cf30032' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_vuehelpers_6fc57a66 from 'nuxt_plugin_vuehelpers_6fc57a66' // Source: ..\\packages\\plugins\\vue-helpers (mode: 'all')
import nuxt_plugin_index_d85798d0 from 'nuxt_plugin_index_d85798d0' // Source: ..\\packages\\plugins\\mixins\\_index (mode: 'all')
import nuxt_plugin_index_2c914f16 from 'nuxt_plugin_index_2c914f16' // Source: ..\\packages\\plugins\\helpers\\_index (mode: 'all')
import nuxt_plugin_axioscache_14cdec93 from 'nuxt_plugin_axioscache_14cdec93' // Source: ..\\packages\\plugins\\axios-cache (mode: 'all')
import nuxt_plugin_date_607eb91a from 'nuxt_plugin_date_607eb91a' // Source: ..\\packages\\plugins\\filters\\date (mode: 'all')
import nuxt_plugin_format_3fe31663 from 'nuxt_plugin_format_3fe31663' // Source: ..\\packages\\plugins\\filters\\format (mode: 'all')
import nuxt_plugin_formatWithUnit_9ea6da26 from 'nuxt_plugin_formatWithUnit_9ea6da26' // Source: ..\\packages\\plugins\\filters\\formatWithUnit (mode: 'all')
import nuxt_plugin_currencyUnit_25416aa1 from 'nuxt_plugin_currencyUnit_25416aa1' // Source: ..\\packages\\plugins\\filters\\currencyUnit (mode: 'all')
import nuxt_plugin_localstorage_c8b4e57e from 'nuxt_plugin_localstorage_c8b4e57e' // Source: ..\\packages\\plugins\\local-storage (mode: 'all')
import nuxt_plugin_localaxios_49c450bc from 'nuxt_plugin_localaxios_49c450bc' // Source: ..\\packages\\plugins\\local-axios (mode: 'all')
import nuxt_plugin_integrationsbootstrapicons52e7a4ca_100d15c6 from 'nuxt_plugin_integrationsbootstrapicons52e7a4ca_100d15c6' // Source: .\\integrations.bootstrap-icons.52e7a4ca.js (mode: 'all')
import nuxt_plugin_integrationsi18nlocale7cf4ff26_148d3836 from 'nuxt_plugin_integrationsi18nlocale7cf4ff26_148d3836' // Source: .\\integrations.i18n-locale.7cf4ff26.js (mode: 'all')
import nuxt_plugin_integrationslazythirdpartyonloadclient3de7dd6a_32749688 from 'nuxt_plugin_integrationslazythirdpartyonloadclient3de7dd6a_32749688' // Source: .\\integrations.lazy-third-party-on-load.client.3de7dd6a.js (mode: 'client')
import nuxt_plugin_integrationsmodalproviderclient68a0ea24_af2c3df8 from 'nuxt_plugin_integrationsmodalproviderclient68a0ea24_af2c3df8' // Source: .\\integrations.modal-provider.client.68a0ea24.js (mode: 'client')
import nuxt_plugin_integrationsvueclickoutsideclientcdb62150_628f4cf8 from 'nuxt_plugin_integrationsvueclickoutsideclientcdb62150_628f4cf8' // Source: .\\integrations.vue-click-outside.client.cdb62150.js (mode: 'client')
import nuxt_plugin_integrationsvuehighchartsclient69b230bb_53d4f3d6 from 'nuxt_plugin_integrationsvuehighchartsclient69b230bb_53d4f3d6' // Source: .\\integrations.vue-highcharts.client.69b230bb.js (mode: 'client')
import nuxt_plugin_integrationsvuejsmodalclient61558c6d_77ea15a0 from 'nuxt_plugin_integrationsvuejsmodalclient61558c6d_77ea15a0' // Source: .\\integrations.vue-js-modal.client.61558c6d.js (mode: 'client')
import nuxt_plugin_integrationsvueprintsclient495ef7ea_26ea0e35 from 'nuxt_plugin_integrationsvueprintsclient495ef7ea_26ea0e35' // Source: .\\integrations.vue-prints.client.495ef7ea.js (mode: 'client')
import nuxt_plugin_integrationsvuetoastnotificationclient706a5ed6_efef5074 from 'nuxt_plugin_integrationsvuetoastnotificationclient706a5ed6_efef5074' // Source: .\\integrations.vue-toast-notification.client.706a5ed6.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"charset","charset":"utf-8"}],"htmlAttrs":{"lang":"en","prefix":"og: https:\u002F\u002Fogp.me\u002Fns#","data-theme":"light"},"bodyAttrs":{"id":"top-page"},"script":[],"link":[{"rel":"shortcut icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"apple-touch-icon","sizes":"96x96","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"apple-touch-icon","sizes":"144x144","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"apple-touch-icon","sizes":"192x192","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"preload","href":"\u002Ficons\u002Fbootstrap-icons.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7d1224e2 === 'function') {
    await nuxt_plugin_plugin_7d1224e2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1354cf08 === 'function') {
    await nuxt_plugin_pluginutils_1354cf08(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6d51f6c7 === 'function') {
    await nuxt_plugin_pluginrouting_6d51f6c7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_fb367bf0 === 'function') {
    await nuxt_plugin_pluginmain_fb367bf0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6cf30032 === 'function') {
    await nuxt_plugin_axios_6cf30032(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehelpers_6fc57a66 === 'function') {
    await nuxt_plugin_vuehelpers_6fc57a66(app.context, inject)
  }

  if (typeof nuxt_plugin_index_d85798d0 === 'function') {
    await nuxt_plugin_index_d85798d0(app.context, inject)
  }

  if (typeof nuxt_plugin_index_2c914f16 === 'function') {
    await nuxt_plugin_index_2c914f16(app.context, inject)
  }

  if (typeof nuxt_plugin_axioscache_14cdec93 === 'function') {
    await nuxt_plugin_axioscache_14cdec93(app.context, inject)
  }

  if (typeof nuxt_plugin_date_607eb91a === 'function') {
    await nuxt_plugin_date_607eb91a(app.context, inject)
  }

  if (typeof nuxt_plugin_format_3fe31663 === 'function') {
    await nuxt_plugin_format_3fe31663(app.context, inject)
  }

  if (typeof nuxt_plugin_formatWithUnit_9ea6da26 === 'function') {
    await nuxt_plugin_formatWithUnit_9ea6da26(app.context, inject)
  }

  if (typeof nuxt_plugin_currencyUnit_25416aa1 === 'function') {
    await nuxt_plugin_currencyUnit_25416aa1(app.context, inject)
  }

  if (typeof nuxt_plugin_localstorage_c8b4e57e === 'function') {
    await nuxt_plugin_localstorage_c8b4e57e(app.context, inject)
  }

  if (typeof nuxt_plugin_localaxios_49c450bc === 'function') {
    await nuxt_plugin_localaxios_49c450bc(app.context, inject)
  }

  if (typeof nuxt_plugin_integrationsbootstrapicons52e7a4ca_100d15c6 === 'function') {
    await nuxt_plugin_integrationsbootstrapicons52e7a4ca_100d15c6(app.context, inject)
  }

  if (typeof nuxt_plugin_integrationsi18nlocale7cf4ff26_148d3836 === 'function') {
    await nuxt_plugin_integrationsi18nlocale7cf4ff26_148d3836(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationslazythirdpartyonloadclient3de7dd6a_32749688 === 'function') {
    await nuxt_plugin_integrationslazythirdpartyonloadclient3de7dd6a_32749688(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsmodalproviderclient68a0ea24_af2c3df8 === 'function') {
    await nuxt_plugin_integrationsmodalproviderclient68a0ea24_af2c3df8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsvueclickoutsideclientcdb62150_628f4cf8 === 'function') {
    await nuxt_plugin_integrationsvueclickoutsideclientcdb62150_628f4cf8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsvuehighchartsclient69b230bb_53d4f3d6 === 'function') {
    await nuxt_plugin_integrationsvuehighchartsclient69b230bb_53d4f3d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsvuejsmodalclient61558c6d_77ea15a0 === 'function') {
    await nuxt_plugin_integrationsvuejsmodalclient61558c6d_77ea15a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsvueprintsclient495ef7ea_26ea0e35 === 'function') {
    await nuxt_plugin_integrationsvueprintsclient495ef7ea_26ea0e35(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsvuetoastnotificationclient706a5ed6_efef5074 === 'function') {
    await nuxt_plugin_integrationsvuetoastnotificationclient706a5ed6_efef5074(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
